import { render, staticRenderFns } from "./StartseiteSubventionen.vue?vue&type=template&id=7765f619"
import script from "./StartseiteSubventionen.vue?vue&type=script&lang=js"
export * from "./StartseiteSubventionen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports